import { render, staticRenderFns } from "./ForgotPasswordScreen.vue?vue&type=template&id=66d2dad2&scoped=true"
import script from "./ForgotPasswordScreen.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordScreen.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordScreen.vue?vue&type=style&index=0&id=66d2dad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2dad2",
  null
  
)

export default component.exports